import { createAsyncThunk } from '@reduxjs/toolkit'
import { pageSetupManagementApi } from '@services/api/pageSetupManagementApi'
import { pageSetupAreaManagementApi } from '@services/api/pageSetupAreaManagementApi'

export const fetchList = createAsyncThunk(
  'pageSetupManagement/fetchList',
  async (params: TPageSetupManagement.TState['searchParams'], { rejectWithValue }) => {
    try {
      const response = await pageSetupManagementApi.fetchList(params)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const create = createAsyncThunk(
  'pageSetupManagement/create',
  async (data: TPageSetupManagement.TState['pageSetupUpsert']['data'], { rejectWithValue }) => {
    try {
      const response = await pageSetupManagementApi.create(data)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const update = createAsyncThunk(
  'pageSetupManagement/update',
  async (data: TPageSetupManagement.TState['pageSetupUpsert']['data'], { rejectWithValue }) => {
    try {
      const response = await pageSetupManagementApi.update(data)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchSingle = createAsyncThunk(
  'pageSetupManagement/fetchSingle',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await pageSetupManagementApi.fetchSingle(id)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const deletePageSetup = createAsyncThunk(
  'pageSetupManagement/deletePageSetup',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await pageSetupManagementApi.delete(id)
      return response
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchListArea = createAsyncThunk(
  'pageSetupManagement/fetchListArea',
  async (_, { rejectWithValue }) => {
    try {
      const response = await pageSetupAreaManagementApi.fetchList()
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const createArea = createAsyncThunk(
  'pageSetupManagement/createArea',
  async (data: TPageSetupManagement.TState['pageSetupAreaUpsert']['data'], { rejectWithValue }) => {
    try {
      const response = await pageSetupAreaManagementApi.create(data)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const updateArea = createAsyncThunk(
  'pageSetupManagement/updateArea',
  async (data: TPageSetupManagement.TState['pageSetupAreaUpsert']['data'], { rejectWithValue }) => {
    try {
      const response = await pageSetupAreaManagementApi.update(data)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchSingleArea = createAsyncThunk(
  'pageSetupManagement/fetchSingleArea',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await pageSetupAreaManagementApi.fetchSingle(id)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const deleteArea = createAsyncThunk(
  'pageSetupManagement/deleteArea',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await pageSetupAreaManagementApi.delete(id)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchDisplayScreenOptions = createAsyncThunk(
  'pageSetupManagement/fetchDisplayScreenOptions',
  async (_, { rejectWithValue }) => {
    try {
      const response = await pageSetupManagementApi.fetchDisplayScreenOptionList()
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchFilterAndSortOptions = createAsyncThunk(
  'pageSetupManagement/fetchFilterAndSortOptions',
  async (code: string, { rejectWithValue }) => {
    try {
      const response = await pageSetupManagementApi.fetchSortedAndFilterOptions(code)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)
